import {
  GET_IMOLOGHISTORY,
  SHOW_IMOLOGHISTORY_LOADING,
  IMOLOGHISTORY_ERROR,
  GET_IMOLOGHISTORY_DETAILS,
  SHOW_EDIT_IMOLOGHISTORY_LOADING,
  EDIT_IMOLOGHISTORY,
  DELETE_IMOLOGHISTORY,
  CREATE_IMOLOGHISTORY,
} from '../actions/types';

/**
 * 804-maco
 */

const initialState = {
  imologhistorylist: [],
  imologhistoryID: null,
  imologhistoryDetails: null,
  imologhistoryLoading: false,
  editImologhistoryLoading: false,
  error: {},
};

// eslint-disable-next-line
export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SHOW_IMOLOGHISTORY_LOADING:
      return {
        ...state,
        imologhistoryLoading: true,
      };
    case SHOW_EDIT_IMOLOGHISTORY_LOADING:
      return {
        ...state,
        editImologhistoryLoading: true,
      };
    case GET_IMOLOGHISTORY:
      return {
        ...state,
        imologhistorylist: payload,
        imologhistoryLoading: false,
      };
    case CREATE_IMOLOGHISTORY:
      return {
        ...state,
        imologhistorylist: [payload, ...state.imologhistorylist],
        editImologhistoryLoading: false,
      };
    case EDIT_IMOLOGHISTORY:
      return {
        ...state,
        imologhistorylist: state.imologhistorylist.map((item) =>
          item._id === payload._id
            ? {
                ...item,
                name: payload.name,
              }
            : item
        ),
        editImologhistoryLoading: false,
      };
    case GET_IMOLOGHISTORY_DETAILS:
      return {
        ...state,
        imologhistoryDetails: payload,
      };
    case DELETE_IMOLOGHISTORY:
      return {
        ...state,
        imologhistorylist: state.imologhistorylist.filter(
          (item) => item._id !== payload
        ),
        editImologhistoryLoading: false,
        imologhistoryLoading: false,
      };
    case IMOLOGHISTORY_ERROR:
      return {
        ...state,
        error: payload,
        imologhistoryLoading: false,
      };
    default:
      return state;
  }
}
